module.exports = __webpack_public_path__ + "9a56fbe0054bc752b073cd9887dcf76a.svg";